// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"645abdad","432":"645abdad","441":"645abdad"}[chunkId] + ".chunk.css";
};